/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestSchema } from "./banquetCreateRequestSchema.ts";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveBanquetCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveBanquetCreateStatus201Schema = reserveSchema;

export const orgUnitReserveBanquetCreateResponseSchema = orgUnitReserveBanquetCreateStatus201Schema;

export const orgUnitReserveBanquetCreateDataSchemaJson = banquetCreateRequestSchema.describe(
	"Предметная валидация выполняется MobileOrderCreateSerializer\nвнутри BanquetOrderService, а значит формат корзины полностью идентичен заказу.",
);

export const orgUnitReserveBanquetCreateDataSchemaXml = banquetCreateRequestSchema.describe(
	"Предметная валидация выполняется MobileOrderCreateSerializer\nвнутри BanquetOrderService, а значит формат корзины полностью идентичен заказу.",
);

export const orgUnitReserveBanquetCreateDataSchema = z.union([orgUnitReserveBanquetCreateDataSchemaJson, orgUnitReserveBanquetCreateDataSchemaXml]);
